import { HeadlineType } from '../enums'

export class Headline {
    id!: string
    userId!: string
    name!: string
    type!: HeadlineType
    rank!: number
    details!: string
    doneDate!: Date | null
    expirationDate!: Date | null
    createdOn!: Date
    lastmodifiedOn!: Date
    createdByid!: string
    lastmodifiedByid!: string

    meetingIds: string[] = []
    meetingNames = ''
    userIds: string[] = [] // Multiple user can only be assigned when adding a new ToDo, and multiple ToDos will be created for each user
}
